import { connect } from 'react-redux';

/**
 * Return a component that has the token and user in props.
 */
export var withUser = (Component) => {
  const mapStateToProps = (state) => {
    return {
      token: state ? state.advisory.token : null,
      user: state ? state.advisory.user ? state.advisory.user : {id: null} : {id: null},
    };
  }

  const mapDispatchToProps = (dispatch) => {
    return {};
  }

  const ComponentWithToken = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Component)

  return ComponentWithToken;
}



// WEBPACK FOOTER //
// ./src/utility/withUser.js